import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import AppService from "../../../../Configurations/Appservice";
import { useDispatch } from "react-redux";
import { showSuccessMessage } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";

const PaymentItem = ({ item, onApprove }) => {
  const [isLoading, loading] = useState(false);

  const dispatch = useDispatch();

  const _onSubmit = () => {
    loading(true);
    AppService.put(`v2/partner-payment-transactions/${item.id}/partner-approve`)
      .then((response) => {
        dispatch(showSuccessMessage("Payment approved successfully"));
        onApprove(item);
      })
      .catch(() => {
        loading(false);
      });
  };

  return (
    <Box my={2}>
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={4}>
            <Box>
              <Typography fontSize={16}>Amount</Typography>
              <Typography fontSize={14}>{item.amount}</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Typography fontSize={16}>Method</Typography>
              <Typography fontSize={14}>{item.paymentMethod}</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              {isLoading ? (
                <CircularProgress size={18} />
              ) : (
                <Button onClick={_onSubmit}>Accept</Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default PaymentItem;
